import React, { FunctionComponent } from 'react';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { CircularAvatar } from '../../../common/CustomAvatar';
import { IMeetingBadgeProps } from './types';

export const MeetingBadge: FunctionComponent<IMeetingBadgeProps> = ({ meetingId, toggled, setToggled }) => {
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);

  return (
    meeting && (
      <CircularAvatar
        src={meeting.image}
        title={meeting.title}
        color={meeting.color}
        size="25"
        textSizeRatio={3}
        classes={toggled ? 'toggled' : ''}
        styles={{ marginLeft: '5px' }}
        onClick={setToggled}
      />
    )
  );
};
